import { ReactElement } from 'react';
import { Typography, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import canGoBack from '../../../../router/canGoBack';
import { styled } from 'styled-components';
import { useAtomValue } from 'jotai';
import { blockStyle } from '../../../../components/styles/Block';
import { advisorQueryAtom } from '../states/state';
import DeleteButton from './DeleteButton';

const { Title } = Typography;

const HeaderBlock = styled.header`
  ${blockStyle}
  display: flex;
  align-items: center;
  gap: 12px;
`;

const HeaderTitle = styled(Title)`
  && {
    margin: 0;
  }
`;

const DeleteButtonWrapper = styled.div`
  margin-left: auto;
`;

interface Props {
  title: string;
}

const Header = ({ title }: Props): ReactElement => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const advisorId = Number(id);
  const advisor = useAtomValue(advisorQueryAtom(advisorId));

  return (
    <HeaderBlock>
      <Button
        type='text'
        icon={<ArrowLeftOutlined />}
        onClick={() => {
          if (canGoBack()) {
            void navigate(-1);
          } else {
            void navigate('/advisors');
          }
        }}
      />
      <HeaderTitle level={4}>{title}</HeaderTitle>
      <DeleteButtonWrapper>
        <DeleteButton advisorId={advisorId} name={advisor.name} />
      </DeleteButtonWrapper>
    </HeaderBlock>
  );
};

export default Header;
